import { UserInfoType } from '@/mobile/types/api/mypage/userInfo';
import { atom } from 'recoil';
import persistAtom from '@/states/recoilPersist';

// 利用者情報の初期値を設定
export const userInfoDefaultState: UserInfoType = {
  service_id: '',
  service_type: '',
  ls_name: '',
  fl_name: '',
  ls_name_kn: '',
  fl_name_kn: '',
  gender: '',
  birthday: '',
  relation: '',
  user_type: '',
  declared_date: '',
  declared_state: '',
  not_filtering_type: '',
  not_filtering_reason_cd: '',
  user_info_create_date: '',
  user_info_update_date: '',
  nflt_rsn_update_date: '',
  declared_update_date: '',
};

export const UserInfoState = atom<UserInfoType>({
  key: 'UserInfoState',
  default: userInfoDefaultState,
  effects_UNSTABLE: [persistAtom],
});

export default UserInfoState;
